import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import FacilityNew from "../components/FacilityNew";
import { registerFacility , getManagementCompanyInfo } from "../actions/facilitynew";

const mapStateToProps = (state) => {
  const { facilityNew } = state;
  console.log("facilityNew:", facilityNew);

  return {
    companyinfo: facilityNew.companyinfo,
    loading: true,
    error: facilityNew.error
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      registerFacility,
      getManagementCompanyInfo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FacilityNew);